import React from "react";
import {
  Routes,
  Route,
  Navigate,
  HashRouter as Router,
} from "react-router-dom";

//
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Main Style
import "./App.scss";
import "./assets/fonts/line-awsome/line-awesome.scss";

// Layouts
import Main from "./layouts/Main";
import Auth from "./layouts/Auth";
import User from "./layouts/User";
import StripeCallback from "./layouts/StripeCallback";

// App Pages
import Dashboard from "./pages/app/Dashboard";
import News from "./pages/app/News";
import Events from "./pages/app/Events";
import Alerts from "./pages/app/Alerts";
import CryptoCoins from "./pages/app/CryptoCoins";
import AvailableCoins from "./pages/app/AvailableCoins";
import CoinDetail from "./pages/app/CoinDetail";
import AlertReport from "./pages/app/AlertReport";
import AlertHistory from "./pages/app/AlertHistory";
import Account from "./pages/app/Account/Index";
import FearGeed from "./pages/app/FearGreed/Index";
import Ticket from "./pages/app/Ticket/Tickets";
import NewTicket from "./pages/app/Ticket/NewTicket";
import Portfolio from "./pages/app/Portfolio";
import DollarCost from "./pages/app/DollarCost";
import Products from "./pages/app/Products";
import Notifications from "./pages/app/Notifications";
import NotificationsConfig from "./pages/app/NotificationsConfig/index";

// Auth Pages
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";

// User Pages
import Recovery from "./pages/user/Recovery";
import ResetPassword from "./pages/user/ResetPassword";
import Activate from "./pages/user/Activate";
import AdminLogin from "./pages/user/AdminLogin";

// Stripe Pages
import Cancel from "./pages/stripe-callback/Cancel";
import Success from "./pages/stripe-callback/Success";


function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        {/* Redirect / path to /app */}
        <Route path="/" exact element={<Navigate replace to="/app" />} />
        <Route
          path="/auth"
          exact
          element={<Navigate replace to="/auth/login" />}
        />
        <Route
          path="/user"
          exact
          element={<Navigate replace to="/user/recovery" />}
        />

        {/* Main Layout */}
        <Route path="app" element={<Main />}>
          <Route path="" element={<Dashboard />} />
          <Route path="alerts" element={<Alerts />} />
          <Route path="events" element={<Events />} />
          <Route path="news" element={<News />} />
          <Route path="crypto-coins" element={<CryptoCoins />} />
          <Route path="available-coins" element={<AvailableCoins />} />
          <Route path="coin-detail/:symbol" element={<CoinDetail />} />
          <Route path="alert-report" element={<AlertReport />} />
          <Route path="alerts-history" element={<AlertHistory />} />
          <Route path="account" element={<Account />} />
          <Route path="fear-greed" element={<FearGeed />} />
          <Route path="ticket" element={<Ticket />} />
          <Route path="new-ticket" element={<NewTicket />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="dollar-cost-avg" element={<DollarCost />} />
          {/* <Route path="Indicators" element={<Products />} /> */}
          <Route path="notifications" element={<Notifications />} />
          <Route path="notifications-config" element={<NotificationsConfig />} />
        </Route>

        {/* Auth Layout */}
        <Route path="auth" element={<Auth />}>
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
        </Route>

        {/* User Layout */}
        <Route path="user" element={<User />}>
          <Route path="recovery" element={<Recovery />} />
          <Route path="reset-password/:token" element={<ResetPassword />} />
          <Route path="activate/:token" element={<Activate />} />
          <Route path="admin-login/:token" element={<AdminLogin />} />
        </Route>

        {/* Stripe Callback Layout */}
        <Route path="stripe-callback" element={<StripeCallback />}>
          <Route path="cancel" element={<Cancel />} />
          <Route path="success" element={<Success />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
